export default __webpack_public_path__ + "static/media/Gujarati 15th Finance Commsn Water Sanitation Fund Advisory.f6515205.pdf";